import * as Http from "./Http.Client";

export const addFavoritesProduct = (productSlug,slug="product") => {
	return Http.Put(`api/v1/favorite/${productSlug}/${slug}`, {},{}, true)
		.then(result => result ? result : false);
};
export const removeFavoritesProduct = (productSlug) => {
	return Http.Delete(`api/v1/favorite/${productSlug}`, {}, {}, true)
		.then(result => result ? result : false);
};